import { Credentials } from "../../model/auth/Credentials.js";
import { requestJson } from "../../../packages/fetcher/fetcherFunctions.js";

/**
 * Runs the login request.
 */
export const login = async (username: string, password: string) => {
  await requestJson<void, Credentials>("/api/auth/login", "POST", { username, password });
};

/**
 * Runs the logout request.
 */
export const logout = async () => {
  await requestJson<void, undefined>("/api/auth/logout", "POST", undefined);
};
